let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("r9Hn2")).then(() => parcelRequire('7oWcK'));